import axios from 'axios';
import { ID } from 'types';
import { ApiUrl } from './ApiUtils';

export interface NsbEventConfig {
  allow_baseline_override?: boolean;
  allow_negotiation_override?: boolean;
  baseline_flavor?: string;
  baseline_method?: string;
  buyer_picked_line_item_ids?: ID[];
  no_baseline_reason?: string;
  starting_flavor?: string;
  starting_method?: string;
}

// Keys are merged server-side, so a partial config is fine.
export const persistNsbConfig = (eventId: ID, config: NsbEventConfig): Promise<unknown> => {
  const url = ApiUrl(`/events/${eventId}/smart_baseline_config`);

  return axios.patch(url, { smart_baseline_config: config });
};
